import React from 'react';
import { CellProps, isEnumControl, RankedTester, rankWith, WithClassname } from '@jsonforms/core';
import { ChakraSelect } from '../chakra-controls';
import { withNamedJsonFormsEnumCellProps } from '@/forms-renderers/chakra-ui/utils/withNamedJsonFormsHOC';

export const ChakraEnumCell = (props: CellProps & WithClassname) => <ChakraSelect {...props} />;
export const chakraEnumCellTester: RankedTester = rankWith(2, isEnumControl);

export default withNamedJsonFormsEnumCellProps(ChakraEnumCell);
